import { useEffect, useRef } from 'react'

function useClickOutside(close: React.MouseEventHandler<HTMLButtonElement>, opened: boolean) {
  const ref = useRef<HTMLElement>(null)

  useEffect(() => {
    // @ts-expect-error - event typing
    const handleClickOutside = (event) => {
      if (!opened) return
      if (ref.current && !ref.current.contains(event.target)) {
        close(event)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [ref, close, opened])

  return ref
}

export default useClickOutside
